import styled from 'styled-components'
import { FlexContainer } from '~/components/Layout'

export const StyledProtocolsWrapper = styled(FlexContainer)`
  cursor: pointer;
`

export const StyledProtocolIcon = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 50%;
`

export const StyledProtocolTextIcon = styled.span`
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #f0f1f3;
  color: ${({ theme }) => theme.colors.textCaption};
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
`

export const StyledDetailTitle = styled.p`
  color: ${({ theme }) => theme.colors.textTitle};
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 0;
`

export const StyledDetailDesc = styled.p`
  margin-top: 16px;
  margin-bottom: 0;
  color: ${({ theme }) => theme.colors.textTitle};
  font-size: 12px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0.2px;
`

export const StyledTokenIcon = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.borderDefault};
  border-width: 0.5px;
  background-color: #fff;
  z-index: 2;
`

export const StyledTokenTextIcon = styled.span`
  display: inline-block;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.borderDefault};
  border-width: 0.5px;
  background-color: ${({ theme }) => theme.colors.textPlaceholder};
  z-index: 2;
  color: #ffffff;
  font-size: 10px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  letter-spacing: -0.3px;
`

export const StyledRoutesWrapper = styled(FlexContainer)`
  margin-top: 20px;
`

export const StyledPercentRouteWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  color: ${({ theme }) => theme.colors.textSubtle};
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2px;
`

export const StyledRoutingDiagramWrapper = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 295px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  padding: 8px;
  margin-left: 8px;
  background: ${({ theme }) => theme.colors.bgSurface};
`

export const StyledPointLine = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 58px);
  overflow: hidden;
  z-index: 1;
`

export const StyledDiagramProtocolsWrapper = styled(FlexContainer)`
  max-width: 52px;
  padding: 4px;
  border-radius: 8px;
  background: #fff;
  z-index: 2;
`

export const StyledProtocolItemWrapper = styled.div`
  position: relative;
`

export const StyledUniswapBadge = styled.img`
  position: absolute;
  left: 10px;
  top: 12px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
`
